import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";
import { Cluster } from "src/app/store/models/industry-page.model";
import { VAIconRegistryService, infoCircle } from "@va/core-library/icons";

@Component({
  selector: "app-cluster-filter",
  templateUrl: "./cluster-filter.component.html",
  styleUrls: ["./cluster-filter.component.scss"],
})
export class ClusterFilterComponent {
  @Input() clusters: Array<Cluster>;
  @Output() clusterChange: EventEmitter<number> = new EventEmitter();
  @Input() selectedCluster: string;
  @Input() isMegaMenuReady: boolean;
  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 24,
      },
    },
  };

  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([infoCircle]);
  }

  onClusterChange(data) {
    this.clusterChange.emit(data);
  }
}
